import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnLprVigilantRead } from './lpr-vigilant-read';

export class VigilantResponse extends SnModel {
  @Expose()
  @Type(() => SnLprVigilantRead)
  public results: SnLprVigilantRead[];

  @Expose()
  public counts: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
